module.exports = __webpack_public_path__ + "static/media/asociaciones-territoriales-mini.74df40e7.png";